import React from 'react';
import {Navigation} from '../Navigation';

export const CanvasNavigation = function(props){
    return (
        <Navigation title="Canvas" icon="cloud" breadcrumb={props.breadcrumb} menu={[
            {
                icon: 'tasks',
                caption: 'Events und Wettprogramm',
                entries: [
                    {
                        icon: 'soccer',
                        caption: 'Events',
                        href: '/canvas/events/'
                    },
                    {
                        icon: 'sitemap',
                        caption: 'Struktur',
                        href: '/canvas/structure/'
                    },
                    {
                        icon: 'flag',
                        caption: 'Ergebnisregeln',
                        href: '/canvas/results/'
                    },
                    {
                        icon: 'paragraph',
                        caption: 'Kombinations-Regeln',
                        href: '/canvas/constraints/'
                    },
                    {
                        icon: 'star',
                        caption: 'Topangebot',
                        href: '/canvas/toplists/'
                    }
                ]
            }
        ]}>
            {props.children}
        </Navigation>
    )
}